

































































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
import { MutationsTypes } from "@/store/modules/delayCodes/mutations";
import { ListItem } from "@/store/modules/delayCodes/utils";
import GuidedHeaderLetter from "@/components/GuidedHeader/GuidedHeaderLetter.vue";
import { ListToBeDisplayed } from "../../store/modules/delayCodes/utils";

@Component({
  components: {
    GuidedHeaderLetter
  }
})
export default class GuidedHeader extends Vue {
  @Prop(Boolean) readonly visible!: boolean;
  @Prop(Boolean) readonly breakdown!: boolean;

  select: number | null = null;

  get selectedList(): ListToBeDisplayed {
    return store.state.delayCodes.selectedListToDisplay;
  }

  get letterProcess(): string | null {
    const selected = store.state.delayCodes.selectedProcessId;
    if (selected === null) {
      return null;
    } else {
      return store.state.delayCodes.allProcesses[selected][0];
    }
  }

  get letterReasons(): string | null {
    const selected = store.state.delayCodes.selectedReasonId;
    if (selected === null) {
      return null;
    } else {
      return store.state.delayCodes.allReasons[selected][0];
    }
  }

  get letterStakeholder(): string | null {
    const selected = store.state.delayCodes.selectedStakeholderId;
    if (selected === null) {
      return null;
    } else {
      return store.state.delayCodes.allStakeholders[selected][0];
    }
  }

  get infoDetailLetterProcess(): string | null {
    const selected = store.state.delayCodes.selectedProcessId;
    if (selected === null) {
      return null;
    } else {
      return store.state.delayCodes.allProcesses[selected];
    }
  }

  get infoDetailLetterReason(): string | null {
    const selected = store.state.delayCodes.selectedReasonId;
    if (selected === null) {
      return null;
    } else {
      return store.state.delayCodes.allReasons[selected];
    }
  }

  get infoDetailLetterStakeholder(): string | null {
    const selected = store.state.delayCodes.selectedStakeholderId;
    if (selected === null) {
      return null;
    } else {
      return store.state.delayCodes.allStakeholders[selected];
    }
  }

  get turnaroundGroupings(): ListItem[] {
    const map = store.state.delayCodes.groupings;
    const turnaroundGroupingsArray: ListItem[] = [];
    Object.keys(map).forEach(function(key) {
      turnaroundGroupingsArray.push({
        id: parseInt(key),
        value: map[key],
        subItemOf: undefined,
        parentOf: []
      });
    });
    turnaroundGroupingsArray.sort((it1, it2) =>
      it1.value < it2.value ? -1 : 1
    );
    if (turnaroundGroupingsArray.length === 1) {
      this.select = turnaroundGroupingsArray[0].id;
      // this.changeGrouping(turnaroundGroupingsArray[0]);
      turnaroundGroupingsArray.push({
        id: null,
        value: "NO FILTER ON GROUPING",
        subItemOf: undefined,
        parentOf: []
      });
    }
    if (store.state.delayCodes.selectedGroupingId === null) {
      this.select = -1;
    }
    return turnaroundGroupingsArray;
  }

  ListToBeDisplayed = ListToBeDisplayed;

  changeGrouping = (elem: ListItem) => {
    if (store.state.delayCodes.selectedGroupingId !== elem.id) {
      store.commit.delayCodes[MutationsTypes.SET_GROUPING_ID](elem.id);
    }
  };

  changeList = (list: ListToBeDisplayed) => {
    store.commit.delayCodes[MutationsTypes.SET_SELECTED_LIST](list);
  };

  goToExpertMode = () => {
    store.commit.delayCodes[MutationsTypes.RESET_SELECTION]();
    this.$router.push("expert-mode");
  };
}
